(function () {
  'use strict';

  var qs = function (selector, root) { return (root || document).querySelector(selector); };
  var qsa = function (selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); };

  var dialog = document.getElementById('cart-dialog');

  /* ---------- Cart count ---------- */
  function setCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function refreshCount() {
    return fetch(window.theme.cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function () {});
  }

  /* ---------- Add to cart without leaving the page ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest ? event.target.closest('[data-product-form]') : null;
    if (!form || !window.fetch || !dialog || typeof dialog.showModal !== 'function') return;

    event.preventDefault();

    var button = qs('[data-add-button]', form);
    var error = qs('[data-form-error]', form);
    if (error) error.textContent = '';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    var restore = function () {
      button.removeAttribute('aria-busy');
      button.disabled = button.getAttribute('data-available') === 'false';
    };

    fetch(window.theme.cartAddUrl + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          if (error) {
            error.textContent = result.data.description || result.data.message || 'We couldn’t add that item. Please try again.';
          }
          restore();
          return;
        }
        var name = result.data.product_title || '';
        if (result.data.variant_title) name += ' - ' + result.data.variant_title;
        qs('[data-dialog-item]', dialog).textContent = name;
        restore();
        refreshCount().then(function () { dialog.showModal(); });
      })
      .catch(function () {
        restore();
        form.submit();
      });
  });

  if (dialog) {
    qsa('[data-dialog-close]', dialog).forEach(function (btn) {
      btn.addEventListener('click', function () { dialog.close(); });
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  }

  /* ---------- Product gallery and variants ---------- */
  var product = qs('[data-product]');
  if (product) {
    var slides = qsa('.gallery-slide[data-media-id]', product);
    var thumbs = qsa('[data-thumb]', product);

    var showMedia = function (id) {
      if (!id) return;
      var found = false;
      slides.forEach(function (slide) {
        var match = slide.getAttribute('data-media-id') === String(id);
        slide.hidden = !match;
        if (match) found = true;
      });
      if (!found) return;
      thumbs.forEach(function (thumb) {
        thumb.setAttribute('aria-current', thumb.getAttribute('data-thumb') === String(id) ? 'true' : 'false');
      });
    };

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.getAttribute('data-thumb')); });
    });

    var visible = slides.filter(function (slide) { return !slide.hidden; })[0];
    if (visible) showMedia(visible.getAttribute('data-media-id'));

    var variantData = qs('[data-variants]');
    var select = qs('[data-variant-select]', product);

    if (variantData && select) {
      var variants = [];
      try { variants = JSON.parse(variantData.textContent); } catch (e) { variants = []; }

      var priceEl = qs('[data-price]', product);
      var button = qs('[data-add-button]', product);
      var label = qs('[data-add-label]', product);

      select.addEventListener('change', function () {
        var variant = variants.filter(function (v) { return String(v.id) === select.value; })[0];
        if (!variant) return;

        priceEl.textContent = '';
        var now = document.createElement('span');
        now.className = 'price-now' + (variant.onSale ? ' is-sale' : '');
        now.textContent = variant.price;
        priceEl.appendChild(now);
        if (variant.onSale) {
          var was = document.createElement('s');
          was.className = 'price-was';
          was.textContent = variant.compare;
          priceEl.appendChild(was);
        }

        button.setAttribute('data-available', variant.available ? 'true' : 'false');
        button.disabled = !variant.available;
        label.textContent = variant.available ? 'Add to cart' : 'Sold out';

        showMedia(variant.mediaId);

        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      });
    }
  }

  /* ---------- Collection filters and sort ---------- */
  qsa('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () {
      var formId = el.getAttribute('form');
      var form = formId ? document.getElementById(formId) : el.form;
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  });

  var filterPanel = qs('[data-filter-panel]');
  if (filterPanel && window.matchMedia && window.matchMedia('(min-width: 900px)').matches) {
    filterPanel.open = true;
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input.matches && input.matches('.filter-group input[type="checkbox"]')) {
      var form = document.getElementById('collection-form');
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    }
  });
})();
